import { supabase } from '@/integrations/supabase/client';

interface JiraTicket {
  summary: string;
  description: string;
  type: 'Bug' | 'Task' | 'Story';
}

export class JiraService {
  async createTicket(ticket: JiraTicket): Promise<any> {
    try {
      const { data, error } = await supabase.functions.invoke('create-jira-ticket', {
        body: ticket
      });

      if (error) {
        throw new Error(`Jira API Error: ${error.message}`);
      }

      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Jira API Error: ${error.message}`);
      }
      throw error;
    }
  }
}

export const jiraService = new JiraService(); 